import React from 'react';
import {Modal} from '@snsw-gel/react';
import TollAccountType from '../../types/tollAccountType';

interface CannotLinkModalProps {
    readonly tollAccountType: TollAccountType;
    readonly onConfirm: () => void;
}

/**
 * A modal for when a user attempts to progress to link a certain account type,
 * but is unable to due to having other account types actively linked.
 */
const CannotLinkModal: React.FC<CannotLinkModalProps> = (
    {
        tollAccountType,
        onConfirm,
    }
) => {
    const title = tollAccountType === TollAccountType.Mixed ?
        'You already have a linked toll account'
        : 'A personal (mixed) toll account is already linked';
    const description = tollAccountType === TollAccountType.Mixed ?
        'To link a mixed toll account, you need to remove all other toll accounts. ' +
        'You can only have one personal, one business or one mixed account linked.'
        : 'To link your personal account you need to remove the existing mixed personal toll account. ' +
        'You can only claim a personal or business rebate on one toll account.';

    return <Modal
        title={title}
        description={description}
        buttons={[{text: 'OK', onClick: onConfirm}]}
    />;
};

export default CannotLinkModal;
